import { useNavigate } from 'react-router-dom';

const useLogout = () => {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem('token'); // Remove the token from localStorage
    // localStorage.removeItem('email');
    // localStorage.removeItem('password');
    navigate('/'); // Redirect to the login page
  };
  return logout;
};

export default useLogout;